var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detailTop)?_c('PatientCard',{attrs:{"detailTop":_vm.detailTop}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }